import React, { Component } from 'react';
import { CHROME } from '$queries/chrome';
import { Query } from '@apollo/react-components';
import DesktopSidenav from '$components/layout/ProductLayout/DesktopSidenav';

class Sidenav extends Component {
  render() {
    const {
      content,
      currentUser,
      defaultOpenKeys,
      defaultSelectedKeys,
      inflatedContent,
      location,
      match,
      mode,
      product,
      toggleSidebarExpanded,
    } = this.props;

    return (
      <Query query={CHROME}>
        {({ loading, _error, data }) => {
          if (loading) {
            return null;
          }

          const {
            chrome: { sidebarExpanded },
          } = data;

          return (
            <DesktopSidenav
              content={content}
              currentUser={currentUser}
              defaultOpenKeys={defaultOpenKeys}
              defaultSelectedKeys={defaultSelectedKeys}
              inflatedContent={inflatedContent}
              location={location}
              match={match}
              mode={mode}
              product={product}
              sidebarExpanded={sidebarExpanded}
              toggleSidebarExpanded={toggleSidebarExpanded}
            />
          );
        }}
      </Query>
    );
  }
}

export default Sidenav;
